/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Limits } from './Limits';
import {
    LimitsFromJSON,
    LimitsFromJSONTyped,
    LimitsToJSON,
} from './Limits';

/**
 * 
 * @export
 * @interface LegalAccount
 */
export interface LegalAccount {
    /**
     * Updated Wallet ID (your choice when you create the Wallet)
     * @type {string}
     * @memberof LegalAccount
     */
    id?: string;
    /**
     * Lemonway Wallet ID (you cannot choose this number). This number is also printed in our Backoffice/Dashboard.
     * @type {number}
     * @memberof LegalAccount
     */
    lemonwayId?: number;
    /**
     * 
     * @type {Limits}
     * @memberof LegalAccount
     */
    limits?: Limits;
}

/**
 * Check if a given object implements the LegalAccount interface.
 */
export function instanceOfLegalAccount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LegalAccountFromJSON(json: any): LegalAccount {
    return LegalAccountFromJSONTyped(json, false);
}

export function LegalAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalAccount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lemonwayId': !exists(json, 'lemonwayId') ? undefined : json['lemonwayId'],
        'limits': !exists(json, 'limits') ? undefined : LimitsFromJSON(json['limits']),
    };
}

export function LegalAccountToJSON(value?: LegalAccount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lemonwayId': value.lemonwayId,
        'limits': LimitsToJSON(value.limits),
    };
}

